import React, { useCallback, useState } from 'react'
import {
  PosterCheckModalHelpIcon,
  PosterCheckToolTipModalList,
  GreenCheckCircleIcon,
  DarkRedCancelIcon,
  ModalCloseButton
} from './column.tooltip.styles'
import { TableHeaderTooltipIcon } from '../../../app/components/statelessDataTable/styles'
import { Modal } from '../../../common/components/modal'

export const PosterCheckModalContent = ({ setPosterCheckModalVisibilityClosed }) => (
  <PosterCheckToolTipModalList
    onBlur={setPosterCheckModalVisibilityClosed}
  >
    <ModalCloseButton onClick={setPosterCheckModalVisibilityClosed} />
    <li>
      <p>
        <GreenCheckCircleIcon />
        The items contained in the shipment have been displayed and the PosterCheck code has been scanned.
      </p>
    </li>
    <li>
      <p>
        <DarkRedCancelIcon />
        The PosterCheck code has not been scanned.
      </p>
    </li>
    <p>
      Once the items have been displayed, either scan the QR code or click <a className="link" href={API_BASE_PATH.replace('api', '#/postercheck')} target="_blank" rel="noopener noreferrer">here</a> to enter the alphanumeric code provided.
    </p>
  </PosterCheckToolTipModalList>
)

export const PosterCheckModal = ({ styling }) => {
  const [posterCheckModalVisibility, setPosterCheckModalVisibility] = useState(false)

  const setPosterCheckModalVisibilityOpen = useCallback(() => {
    setPosterCheckModalVisibility(true)
  })

  const setPosterCheckModalVisibilityClosed = useCallback(() => {
    setPosterCheckModalVisibility(false)
  })

  return (
    <TableHeaderTooltipIcon style={styling}>
      <PosterCheckModalHelpIcon
        onMouseOver={setPosterCheckModalVisibilityOpen}
        onFocus={setPosterCheckModalVisibilityOpen}
      />
      <Modal
        open={posterCheckModalVisibility}
        data-testid="poster-check-tooltip-modal"
        title=""
        component={(
          <PosterCheckModalContent {...{ setPosterCheckModalVisibilityClosed }} />
        )}
        modalCloseDispatch={setPosterCheckModalVisibilityClosed}
        isFullWidth
        maxWidth="sm"
        unsetHeight
      />
    </TableHeaderTooltipIcon>
  )
}
